import ClosingTripNotes from "./ClosingTripNotes";

export default ClosingTripNotes;
